import { formatDateToDDMMYYYYHHMM } from "@/helpers/Dates";
import { capitaliseFirstLetter } from "@/helpers/Text";
import { IPasskey, IRecoveryCode, IWhitelistData } from "@/interfaces/passkeys";
import { ISimpleTableColumn, ISimpleTableRows } from "thrive-components";

export const passkeyTableColumns: Array<ISimpleTableColumn> = [
    { 
        title: "Name", 
        isToggleButton: false,                    
    },
    { 
        title: "Date Added", 
        isToggleButton: false,                    
    },    
    { 
        title: "Last Used", 
        isToggleButton: false,                    
    },
];


export const whitelistTableColumns: Array<ISimpleTableColumn> = [
    { 
        title: "Date Added", 
        isToggleButton: false,                    
    },    
    { 
        title: "IP Address", 
        isToggleButton: false,                    
    },
    { 
        title: "Added By", 
        isToggleButton: false,                    
    },
];

export const recoveryCodesTableColumns: Array<ISimpleTableColumn> = [
    { 
        title: "Date Created", 
        isToggleButton: false,                    
    },
    { 
        title: "Created By", 
        isToggleButton: false,                    
    },    
    { 
        title: "Status", 
        isToggleButton: false,                    
    },
    { 
        title: "Date Used", 
        isToggleButton: false,                    
    },
];

export function formatPasskeyData(passkeyData: IPasskey[]){
    return passkeyData.map((passkey: IPasskey) => ({
        content: [
            <span className="boldened-text">{passkey.name ?? "-"}</span>,
            passkey.dateCreated ? formatDateToDDMMYYYYHHMM(passkey.dateCreated) : "-",
            passkey.lastUsed ? formatDateToDDMMYYYYHHMM(passkey.lastUsed) : "-",
        ],
        controls: []   
    })) as ISimpleTableRows[]
}
    
export function formatRecoveryData(recoveryData: IRecoveryCode[], setShowRevokeModal: ()=>void){
    return recoveryData.map((request: IRecoveryCode) => ({
        content: [
            request.dateCreated ? formatDateToDDMMYYYYHHMM(request.dateCreated) : "-",
            request.createdBy,
            formatRecoveryCodeStatus(request.status),
            request.dateUsed ? formatDateToDDMMYYYYHHMM(request.dateUsed) : "-",
        ],
        controls: request.status === "active" 
            ?   [{content:"Revoke", onClick:setShowRevokeModal}]   
            :   []
    })) as ISimpleTableRows[]
}

export function formatRecoveryCodeStatus(status: string){
    if (status === "active") {
        return <span className="active-status">Active</span>
    } else if (status === "blocked") {
        return <span>{"Blocked (due to failed attempts)"}</span>
    } else {
        return <span>{capitaliseFirstLetter(status)}</span>
    }
}

export function formatWhitelistData(whitelistData: IWhitelistData[], setRemoveIpId: (id: number) => void){
    return whitelistData.map((whitelistIP: IWhitelistData) => ({
        content: [
            whitelistIP.dateAdded ? formatDateToDDMMYYYYHHMM(whitelistIP.dateAdded) : "-",
            <span className="ip-address">{whitelistIP.ipAddress}</span>,
            <span>{whitelistIP.addedBy}</span>,
        ],
        controls: [
            {content:"Remove", onClick: () => setRemoveIpId(whitelistIP.id)}
        ]   
    })) as ISimpleTableRows[]
}